import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Tabs, Button, message } from 'antd';
import moment from 'moment';

import { AutoSizer } from 'react-virtualized';
import 'react-virtualized/styles.css';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as buhtableActions from '../_actions/buhtable';

import TabsYears from '../components/TabsYears';
import TabsMonths from '../components/TabsMonths';
import VirtualTable from '../components/VirtualTable';

const columns = [
    { title: 'Дата', dataIndex: 'dtcreate', date: true, width: 80 },
    { title: 'Сумма', dataIndex: 'sum', width: 90, sum: true },
    { title: 'Чистый мес.оборот', dataIndex: 'monthly_net', width: 90, sum: true },
    { title: 'Хоз.расходы отель', dataIndex: 'house_hotel_spending', width: 90, sum: true },
    { title: 'Чистый мес.доход', dataIndex: 'monthly_profit', width: 90, sum: true, 
        calc: (record, column) => {
            return record['monthly_net'] - record['house_hotel_spending']
        },
        calcDesc: <p>Отображается <b>"Чистый мес.оборот" - "Хоз.расходы отель"</b>.</p>
    },
    { title: 'Кто', dataIndex: 'who', width: 100, select: ['Сова', 'Антон', 'Маркова', 'Мясоедова', 'Ирина', 'Александр', 'ИП Мясоедова'] },
    { title: 'Тип', dataIndex: 'type', width: 100, select: ['нал', 'карта Александр', 'карта Наталья', 'безнал', 'безнал ООО', 'безнал ИП'] },
    { title: 'Название проводки', dataIndex: 'posting_name', width: 210 },
    { title: 'Тип затрат', dataIndex: 'cost_type', width: 100, 
        select: ['продукты', 'продажи ресторан', 'продажи отель', 'реклама ресторан', 'реклама отель', 'зп отель', 'зп ресторан', 
            'комм.платежи', 'расходники отель', 'расходники ресторан', 'дивиденты'
        ] 
    },
    { title: 'Продукты', dataIndex: 'products', width: 100, sum: true,
        calc: (record, column) => {
            return record['cost_type'] === 'продукты'
                ? record['sum']
                : 0
        },
        calcDesc: <p>Если <b>"Тип затрат" = "продукты"</b>, 
            отображается <b>"Сумма"</b>, иначе - <b>0</b>.
        </p>
    },
    { title: 'Ресторан', dataIndex: 'restaurant', width: 100, sum: true,
        calc: (record, column) => {
            return record['cost_type'] === 'продажи ресторан'
            && record['project'] === 'ресторан Плес'
                ? record['sum'] - record['products']
                : 0
        },
        calcDesc: <p>Если <b>"Тип затрат" = "продажи ресторан"</b>
            <b> и "Проект" = "ресторан Плес"</b>, отображается - <b>
            "Сумма" - "Продукты"</b>, иначе - <b>0</b>.
        </p>
    },     
    { title: 'Хоз.расходы ресторан', dataIndex: 'house_restaurant_spending', width: 100, sum: true },
    { title: 'Проект', dataIndex: 'project', width: 100, select: ['ресторан Плес', 'гостиница Плес'] },
    { title: 'Наличные', dataIndex: 'cash', width: 100, sum: true,
        calc: (record, column) => {
            return record['type'] === 'нал'
                ? record['sum']
                : 0
        },
        calcDesc: <p>Если <b>"Тип" = "нал"</b>
            , отображается - <b>"Сумма"</b>, иначе - <b>0</b>.
        </p>
    },
    { title: 'ИП безнал', dataIndex: 'ip_non_cash', width: 100, sum: true,
        // calc: (record, column) => record[column.dataIndex] 
        calc: (record, column) => {
            return record['type'] === 'безнал ИП' 
                ? record['sum'] 
                : 0
        },
        calcDesc: <p>Если <b>"Тип" = "безнал ИП"</b>
            , отображается - <b>"Сумма"</b>, иначе - <b>0</b>.
        </p>
    },
    { title: 'Безналичные (все)', dataIndex: 'non_cash', width: 100, sum: true,
        calc: (record, column) => {
            return ['безнал', 'безнал ИП', 'безнал ООО'].indexOf(record['type']) > -1
                ? record['sum'] 
                : 0
        },
        calcDesc: <p>Если <b>"Тип" = "безнал"</b> или <b>"безнал ИП"</b> или <b>"безнал ООО"</b>
            , отображается - <b>"Сумма"</b>, иначе - <b>0</b>.
        </p>        
    },
    { title: 'Мясоедова', dataIndex: 'myasoedova', width: 100, sum: true,
        calc: (record, column) => {
            return record['who'] === 'Мясоедова' 
                ? record['sum'] 
                : 0
        },
        calcDesc: <p>Если <b>"Кто" = "Мясоедова"</b>
            , отображается - <b>"Сумма"</b>, иначе - <b>0</b>.
        </p>          
    },
    { title: 'Александр', dataIndex: 'aleksandr', width: 30 }
];

class BuhTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            year: moment().year().toString(),
            month: (moment().month() + 1).toString(),
        }
    }

    componentDidMount() {
        const { year, month } = this.state;
        const { token } = this.props;
        this.props.buhtableRecordsGet(year, month, token)
    }

    componentWillReceiveProps(props) {
        props.error && message.error(props.error, 3)
    }

    handleChangeYear = (year) => {
        const { token } = this.props;
        this.setState({ 
            year 
        }, () => this.props.buhtableRecordsGet(this.state.year, this.state.month, token))
    }

    handleChangeMonth = (month) => {
        const { token } = this.props;
        this.setState({ 
            month
        }, () => this.props.buhtableRecordsGet(this.state.year, this.state.month, token))
    }

    handleAddRecord = () => {
        const { year, month } = this.state;
        const { token } = this.props;
        this.props.buhtableRecordCreate(year, month, token)
    }

    handleChangeCell = (id, record) => {
        const { year } = this.state;
        const { token } = this.props;
        this.props.buhtableRecordUpdate(year, record, token)
    }

    render() { 
        const { year, month } = this.state;
        const { summary, source, loading } = this.props;
        return <div className={'page page-white'}>
            <Helmet>
                <title>Бухгалтерия</title>
            </Helmet>
            <div className={'page-autosizer'}>
                <TabsYears 
                    style={{ width: '100%' }} 
                    onChange={this.handleChangeYear} 
                    year={year} 
                />
                <TabsMonths 
                    style={{ height: '100%', width: 51, float: 'left' }}
                    onChange={this.handleChangeMonth} 
                    month={month} 
                />
                <AutoSizer>
                {({ height, width }) => (
                    <div style={{ height, width, paddingLeft: 50 }}>
                        <VirtualTable
                            columns={columns} 
                            source={source}
                            summary={summary}
                            loading={loading}
                            onChangeCell={this.handleChangeCell}
                        />
                        <Button 
                            icon={'plus'}
                            style={{ marginTop: 5, marginLeft: 4 }} 
                            onClick={this.handleAddRecord} 
                        />
                    </div>
                )}
                </AutoSizer>
            </div>
        </div>
    }
};

const mapStateToProps = (state) => {
    const { source, summary, loading, error } = state.buhtable;
    const { token } = state.user;
    return {
        source: source,
        summary: summary,
        loading: loading,
        error: error,
        token: token
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(buhtableActions, dispatch)
};
 
export default connect(mapStateToProps, mapDispatchToProps)(BuhTable);


// WEBPACK FOOTER //
// ./src/pages/BuhTable.jsx